import { SiteInfo } from "../../sites/shared/sites.entities";
import { VisitsController } from "../components/visits-tab/scripts/visits.controller";
import { Visit, VisitEvent } from "../components/visits-tab/scripts/visits.entities";
import { VisitLookup } from "../components/visits-tab/scripts/visits.lookup";
import { FilterSection, IFilteringParent } from "./data-completeness.filter";
import { DateUpdatedSection } from "../../../../shared/components/date-updated-section/date-updated-section.view";
import { Study } from "../../../../shared/entities/scripts/study";
import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { Site } from "../../../../shared/entities/scripts/site";
import { OutcomesController } from "../components/outcomes-tab/scripts/outcomes.controller";
import { SetActiveTab } from "../../../../shared/scripts/tab-utilities";


export class DataCompletenessPage implements ISiteInfo, IFilteringParent {

    siteInfoList: SiteInfo[];
    siteInfoMap: Map<number, SiteInfo>;

    allStudies: Study[] = [];
    allAppendices: Appendix[] = [];
    allSites: Site[] = [];

    filter: FilterSection;

    selectedData: string; //visits, outcomes
    selectedView: string; //view-summary, view-tabular

    //going to try lazy loading data for different views in case assessments is large
    visitController: VisitsController = undefined;
    outcomeController: OutcomesController = undefined;

    constructor(visitTimingJson: any, primaryOutcomesJson: any, siteInfoJson: any, lastUpdatedJson: any) {

        $(() => {

            new DateUpdatedSection(lastUpdatedJson, false, true, false);

            //console.log(visitTimingJson);
            //console.log(siteInfoJson);

            this.siteInfoList = SiteInfo.Parse(siteInfoJson);
            this.siteInfoMap = new Map<number, SiteInfo>();
            this.siteInfoList.forEach((site: SiteInfo) => {
                if (!this.siteInfoMap.has(site.SiteNumber)) { this.siteInfoMap.set(site.SiteNumber, site); }
            });

            this.visitController = new VisitsController(this, visitTimingJson);
            this.outcomeController = new OutcomesController(this, primaryOutcomesJson);

            this.initializeFilters();

            this.selectedView = "view-summary";
            this.setTypeOfData("visits");
            
            this.FilterUpdated();

            $('#loading-indicator').hide();
            $('.loaded-content').removeClass('invisible');
        });
    }

    //FilterUpdated(studyIds: number[], appendixIds: number[], siteIds: number[], visitIds: number[]) {
    FilterUpdated() {

        if (this.selectedData == "visits") {
            this.visitController.FilterUpdated(this.filter.selectedStudyIds, this.filter.selectedAppendixIds, this.filter.selectedSiteIds, this.filter.selectedVisitIds, this.filter.selectedVisitRequiredIds);
        }
        else if (this.selectedData == "outcomes") {
            this.outcomeController.FilterUpdated(this.filter.selectedStudyIds, this.filter.selectedAppendixIds, this.filter.selectedSiteIds, this.filter.selectedOutcomeIds);
        }
    }

    GetSiteName(siteNumber: number): string {
        return this.siteInfoMap.get(siteNumber).getSiteNameNumber();
    }

    initializeFilters(): void {
        let foundSiteIds: string[] = [];
        let foundStudyIds: number[] = [];
        let foundAppendixIds: number[] = [];

        //assumes visits is comprehensive list across data views
        this.visitController.allVisitEvents.forEach((v: VisitEvent) => {

            if (!foundSiteIds.includes(v.SiteNumber + "-" + v.StudyId)) { foundSiteIds.push(v.SiteNumber + "-" + v.StudyId); }
            if (!foundStudyIds.includes(v.StudyId)) {
                this.allStudies.push(new Study(v.StudyId, Study.GetStudyName(v.StudyId)));
                foundStudyIds.push(v.StudyId);
            }

            if (!foundAppendixIds.includes(v.AppendixId)) {
                this.allAppendices.push(new Appendix(v.AppendixId, v.StudyId, Appendix.GetAppendixName(v.AppendixId)));
                foundAppendixIds.push(v.AppendixId);
            }
        });

        let foundSiteMap: Map<number, Site> = new Map<number, Site>();
        this.siteInfoList.forEach((s: SiteInfo) => {
            if (foundSiteIds.includes(s.SiteNumber + "-" + s.StudyId)) {
                if (foundSiteMap.has(s.SiteNumber)) {
                    foundSiteMap.get(s.SiteNumber).StudyIds.push(s.StudyId);
                }
                else {
                    let newSite: Site = new Site(s.SiteNumber, s.getSiteNameNumber());
                    newSite.StudyIds.push(s.StudyId);
                    foundSiteMap.set(s.SiteNumber, newSite);
                }
            }
        });
        this.allSites = Array.from(foundSiteMap.values()).sort((a: Site, b: Site) => a.Name.localeCompare(b.Name));

        this.filter = new FilterSection(this.allStudies, this.allAppendices, this.allSites, this.visitController.allVisits, this.visitController.allVisitRequired, this.outcomeController.allOutcomes, this);

    }

    resetFilters(): void {
        this.filter.resetFilters();
    }

    setTypeOfData(newData: string): void {
        //console.log("setTypeOfData", newData);

        this.selectedData = newData;
        if (this.selectedData == "visits") { SetActiveTab("data-completeness-tabs", "visits-tab"); this.setView(""); this.updateVisibleFilters(); }
        else if (this.selectedData == "outcomes") { SetActiveTab("data-completeness-tabs", "outcomes-tab"); this.setView(""); this.updateVisibleFilters(); }

        this.FilterUpdated();
    }

    setView(newView: string): void {

        //on data type change, stay on high-level tab, but reset to default view
        if (newView.length == 0) {
            if (this.selectedView.includes("summary")) { newView = "view-summary"; }
            else if (this.selectedView.includes("datatable")) { newView = "view-datatable"; }
        }

        //console.log("setView: ", newView, this.selectedData);

        this.selectedView = newView;

        if (this.selectedData == "visits") {
            this.visitController.setView(newView);
        }
        else if (this.selectedData == "outcomes") {
            this.outcomeController.setView(newView);
        }
    }

    updateVisibleFilters(): void {

        if (this.selectedData == "visits") {
            $('#visit-filter').show();
            $('#visit-required-filter').show();
            $('#outcome-filter').hide();
        }
        else if (this.selectedData == "outcomes") {
            $('#visit-filter').hide();
            $('#visit-required-filter').hide();
            $('#outcome-filter').show();

        }
    }

    exportTable(): void {
        if (this.selectedView == "visits") {
            this.visitController.exportTable();
        }
        else if (this.selectedView == "outcomes") {
            this.outcomeController.exportTable();
        }
    }
}

export interface ISiteInfo {
    siteInfoList: SiteInfo[];
    GetSiteName(siteNumber: number): string;
}